import { getFieldValue } from '@sitecore-jss/sitecore-jss-nextjs';
import withValidDatasourceCheck from 'lib/enhancers/withValidDatasourceCheck';

import { BlogConstants, BlogPostsRequestByFilter, FeaturedBlogPostsProps } from 'models/blog-types';
import withStyles from 'lib/enhancers/withStyles';
import { RecordOfFields } from 'models/fields';
import compose from 'lib/enhancers/compose';
import { getIdsFromArray } from 'lib/utils';
import BlogPostsGrid from './BlogPostsGrid';
import classNames from 'classnames/bind';
import styles from './Blog.module.scss';

const FeaturedBlogPosts = (props: FeaturedBlogPostsProps): React.JSX.Element => {
  const cx = classNames.bind(styles);
  const cardColumns = 3;

  const { className, fields } = props;
  const { title, description, blogAudience, postsToShow, headingLevel, textStyle, showFeaturedPostsOnly } = fields;

  const headingLevelItemField = headingLevel?.fields as RecordOfFields;
  const titleHeadingLevelValue =
    getFieldValue<string>(headingLevelItemField, 'Value') || BlogConstants.DefaultFeaturedHeadingLevel;

  const titleTextStyleItemField = textStyle?.fields as RecordOfFields;
  const titleTextStyleValue =
    getFieldValue<string>(titleTextStyleItemField, 'Value') || BlogConstants.DefaultFeaturedHeadingStyle;

  const maxPostsToShow = +(postsToShow?.value || BlogConstants.DefaultFeaturedItems);

  const blogPostsRequest: BlogPostsRequestByFilter = {
    blogAudience: getIdsFromArray(blogAudience),
    postsToShow: maxPostsToShow,
    showFeaturedPostsOnly: showFeaturedPostsOnly?.value ? true : false,
  };

  return (
    <BlogPostsGrid
      className={cx('featured-blog-posts', className)}
      titleHeadingLevelValue={titleHeadingLevelValue}
      titleTextStyleValue={titleTextStyleValue}
      blogPostsRequest={blogPostsRequest}
      cardColumns={cardColumns}
      description={description}
      title={title}
    />
  );
};

export default compose<FeaturedBlogPostsProps>(withValidDatasourceCheck(), withStyles())(FeaturedBlogPosts);
